import dataStatistic from './data-statistic.png';
import coreData from './core-data.png';
import monthData from './month-data.png';
import transactionData from './transaction-data.png';
import reviewCoupon from './review-coupon.png';
import washPackage from './wash-package.png';
import storeRevenue from './store-revenue.png';
import groupMap from './group-map.png';
import rechargePackage from './recharge-package.png';
import advertisingSetting from './advertising-setting.png';
import OrderRecord from './order-record.png';
import RechargeRecord from './recharge-record.png';
import VerificationRecord from './verification-record.png';
import AfterSalesOrder from './after-sales-order.png';
import BalanceRefund from './balance-refund.png';
import OrderReview from './order-review.png';
import StoreDeviceManagement from './store-device-management.png';
import CarWashFreeStop from './car-wash-free-stop.png';
import CrazyWashDay from './crazy-wash-day.png';
import WashProblem from './question.png';
import MeituanAuth from './meituan-auth.png';
import StoreMapping from './store-mapping.png';
import UserManagement from './user-management.png';
import Blacklist from './blacklist.png';
import OperationReconciliation from './operation-reconciliation.png';
import MaterialReconciliation from './material-reconciliation.png';
import CustodySettings from './custody-settings.png';
import LocationManagement from './location-management.png';
import AccountPermission from './account-permission.png';
import FindStore from './find-store.png';
import Settings from './settings.png';
import MapAddress from './icon-map_1.svg';
import MapHouse from './icon-households.svg';
import MapEval from './icon-score.svg';
import CivilizedWash from './civilized-wash.png';
import MachineCustomer from './machine-customer.png';
import JoinApply from './join-apply.png';

export const icons = {
    coreData,
    monthData,
    dataStatistic,
    transactionData,
    reviewCoupon,
    washPackage,
    storeRevenue,
    groupMap,
    rechargePackage,
    advertisingSetting,

    OrderRecord,
    RechargeRecord,
    VerificationRecord,
    AfterSalesOrder,
    BalanceRefund,
    OrderReview,

    StoreDeviceManagement,
    CarWashFreeStop,
    CrazyWashDay,
    WashProblem,
    MeituanAuth,
    StoreMapping,

    UserManagement,
    Blacklist,

    OperationReconciliation,
    MaterialReconciliation,
    CustodySettings,
    LocationManagement,
    AccountPermission,

    FindStore,
    Settings,

    MapAddress,
    MapHouse,
    MapEval,
    CivilizedWash,
    MachineCustomer,
    JoinApply,
};